import React from "react";
import InputSearch from "../InputSearch";
import ItemCard from "./ItemCard";

const Items = () => {
  const dummy = new Array(20).fill(null);

  return (
    <div className="bg-white">
      <div className="-mt-14 w-full bg-pinkColor fixed z-50 gap-y-2 flex flex-col justify-center items-center">
        <InputSearch placeholder="Search" />
      </div>
      <div className="flex justify-center items-center gap-x-10 py-4 mt-14">
        <button className="uppercase font-bold text-sm border-b-4 border-pinkColor w-14">
          all
        </button>
        <button className="uppercase font-bold text-sm border-b-4 border-grayColor w-14">
          owned
        </button>
        <button className="uppercase font-bold text-sm">need</button>
      </div>
      <div  className="grid grid-cols-1 md:grid-cols-7 mb-10 gap-x-2 gap-y-2 px-2">
        {dummy.map(val => <ItemCard />)}
      </div>
    </div>
  );
};

export default Items;
